import React, { useState } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Typography,
  IconButton,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { BaseProduct, Batch } from "services/batchService"
import { Table as SharedTable } from "shared"
import { TableContainer as StyledTableContainer } from "../styles"
import DialogEditBatch from "../DialogEditBatch"
import DialogDeleteBatch from "../DialogDeleteBatch"

interface ShowBatchDialogProps {
  openDialog: boolean
  setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>
  onClose: () => void
  isDisabled: boolean
  data: BaseProduct | undefined
  selectedProduct: BaseProduct | undefined
}

const ShowBatchDialog: React.FC<ShowBatchDialogProps> = ({
  openDialog,
  onClose,
  isDisabled,
  data,
  selectedProduct,
}) => {
  const [openEditDialog, setOpenEditDialog] = useState(false)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [selectedBatch, setSelectedBatch] = useState<Batch | null>(null)

  const handleEditBatch = (batch: Batch) => {
    setSelectedBatch(batch)
    setOpenEditDialog(true)
  }

  const handleDeleteBatch = async (batch: Batch) => {
    setSelectedBatch(batch)
    setOpenDeleteDialog(true)
  }

  const handleCloseModal = async () => {
    setOpenDeleteDialog(false)
    setOpenEditDialog(false)
    setSelectedBatch(null)
  }

  const handleConfirmModal = async () => {
    setOpenDeleteDialog(false)
    setOpenEditDialog(false)
    setSelectedBatch(null)
    onClose()
  }
  return (
    <>
      <Dialog open={openDialog} onClose={onClose} fullWidth maxWidth="lg">
        <DialogTitle sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Typography variant="h6">{data?.productBaseName}</Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <StyledTableContainer>
            {data?.Batchs.length === 0 ? (
              <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
                <Typography>Nenhum lote encontrado</Typography>
              </Box>
            ) : (
              <SharedTable<Batch>
                columns={[
                  {
                    field: "batchId",
                    label: "Lote",
                  },
                  {
                    field: "created",
                    label: "Criado em",
                    renderCell: (row: any) =>
                      new Date(row.data.created).toLocaleString("pt-BR", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                      }),
                  },
                  {
                    field: "updated",
                    label: "Atualizado em",
                    renderCell: (row: any) =>
                      new Date(row.data.updated).toLocaleString("pt-BR", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                      }),
                  },
                  {
                    field: "updated",
                    label: "Entrega em",
                    renderCell: (row: any) => row.data.scheduledDate,
                  },
                  {
                    field: "updatedBy",
                    label: "Atualizado por",
                    renderCell: (row: any) => row.data.updatedBy,
                  },
                  {
                    field: "editBatch",
                    label: "",
                    renderCell: (row: any) => (
                      <Box display="flex" gap={1}>
                        <Button
                          variant="contained"
                          color="secondary"
                          size="medium"
                          onClick={() => handleEditBatch(row.data)}
                          disabled={isDisabled}
                        >
                          Editar
                        </Button>
                      </Box>
                    ),
                  },
                  {
                    field: "excludeBatch",
                    label: "",
                    renderCell: (row: any) => (
                      <Box display="flex" gap={1}>
                        <Button
                          variant="contained"
                          color="secondary"
                          size="medium"
                          onClick={() => handleDeleteBatch(row.data)}
                          disabled={isDisabled}
                        >
                          Excluir
                        </Button>
                      </Box>
                    ),
                  },
                ]}
                data={data?.Batchs || []}
                count={data?.Batchs?.length || 0}
                params={{ page: 1, pageSize: 10 }}
                status="success"
                refresh={() => {}}
                onChange={() => {}}
              />
            )}
          </StyledTableContainer>
        </DialogContent>
      </Dialog>
      <DialogEditBatch
        openDialog={openEditDialog}
        onClose={handleCloseModal}
        onConfirm={handleConfirmModal}
        selectedBatch={selectedBatch}
        selectedProduct={selectedProduct}
      />
      <DialogDeleteBatch
        open={openDeleteDialog}
        onClose={handleCloseModal}
        batchToDelete={selectedBatch}
        selectedProduct={selectedProduct}
        onConfirm={handleConfirmModal}
      />
    </>
  )
}

export default ShowBatchDialog
